<template>
  <div>
    <SlickList
      v-model="list"
    >
      <SlickItem
        v-for="(condition, conditionIndex) in list"
        :key="conditionIndex"
        :index="conditionIndex"
        :style="{'z-index': '10000'}"
        class="lv-sort-option-list__slick-item"
      >
        <LvStateQuesCondition
          isSort
          :operator="condition.operator"
          :lowVal="condition.lowVal"
          :highVal="condition.highVal"
          :risk="condition.risk"
          class="lv-state-ques-condition-list__condition"
        />
      </SlickItem>
    </SlickList>
    <LvFlexBox>
      <WsButton001
        red
        mediumButton
        leadingIcon="icon-close"
        class="mr-8"
        @click="$emit('cancel')"
      >
        {{ $t('取消') }}
      </WsButton001>
      <WsButton001
        mediumButton
        leadingIcon="icon-bih-check"
        @click="$_onSubmit()"
      >
        {{ $t('完成') }}
      </WsButton001>
    </LvFlexBox>
  </div>
</template>

<script>
import H_common from '@/helpers/common';
import { SlickList, SlickItem } from "vue-slicksort";

export default {
  components: {
    SlickList,
    SlickItem,
  },
  props: {
    originalList: {
      type: Array,
    }
  },
  data() {
    return {
      list: [],
    }
  },
  mounted() {
    this.list = H_common.deepCopyFunction(this.originalList);
  },
  methods: {
    $_onSubmit() {
      this.$emit('input', this.list);
    },
  }
}
</script>